import React, {Component} from 'react';

export default class MainRowSectionCargaTitulo extends Component {

    render() {
        return (
            <div className='pageHead-mainRow-container'>
                <div className='pageHead-mainRow wrapper'>
                    <h1 className='pageHead-title'>Carga Masiva</h1>


                    <div className='pageHead-mainRow-actions'>
                        <button className='btn btn-primary' onClick={() => {
                            this.props.reiniciarTables();
                            this.props.openModal('seleccionar-adjunto', this)
                        }}>Adjuntar Archivo
                        </button>
                    </div>
                </div>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Inmatriculacion/MainRowSectionCargaTitulo.js